<template>
    <div>
        <draft-menu></draft-menu>

        <teams-list></teams-list>
    </div>
</template>

<script>
import TeamsList from '@/components/TeamsList';
import DraftMenu from '@/components/DraftMenu';

export default {
    name: 'TeamsListView',
    components: {
        TeamsList,
        DraftMenu
    }
};
</script>

<style></style>
